import './webpack-assign';

import '../less/nike-mobile.less';
import '../less/nike-ui.less';

import React from 'react';
import ReactDOM from 'react-dom';
import { dispatch, dispatchSync } from 'nike-re-framejs';
import '@/_http/axios-setup';
import '@/nike-ui';
import 'nike-ui/src/common/logging';
import '@/ab-testing';
import './reframe-setup';
import 'intersection-observer';
import './botdefence/snapshotBotDefence';
import './routing';
import './reklamacia';
import './loginng';
import './message';
import './mytickets';
import './cashins';
import './scoreboards';
import './home';
import './notifications';
import './appdownload';
import './nikeone';
import './fullsearch';
import './article';
import './help';
import './favorites';
import './nike-tv';
import './menu';
import './recentlyvisited';
import './matchOptions';
import './server';
import './betslip';
import './ui';
import { isLoggedIn } from './account/index';
import './initHandlers';
import { initializeCookieBotMobile } from './cookie-consent';
import './betsbanners';
import './legalInformation';
import './charity';
import './onboarding/config';

import NikeRoot from './root/Root';
import { initFirebaseMessaging } from './notifications/init';
import { registerServiceWorker } from './service-worker/registration';
import { measureTime } from './analytics';
import { initAvailableMarketStatsSports } from '@/market-statistics/handlers';
import { removeUnsupportedBrowserBanner } from 'nike-ui/src/common/utils/UnsupportedBrowserBanner';
import { generateSessionId } from 'nike-ui/src/components/dwh-tracking/utils';

if (document.domain.indexOf('nike.sk') > -1) {
    document.domain = 'nike.sk';
}
generateSessionId();
dispatchSync(['application/init/sync', isLoggedIn()]);
dispatch(initAvailableMarketStatsSports);
ReactDOM.render(<NikeRoot />, document.getElementById('ReactRoot'));
measureTime('MainJS');
setTimeout(() => dispatch(['application/init/after']), 2000);

registerServiceWorker()
    .then(initFirebaseMessaging)
    .catch(error => console.error('Error during service worker registration:', error));

initializeCookieBotMobile();
removeUnsupportedBrowserBanner();
